import EmptyState from "@/components/empty-state";
import PageHeader from "@/components/page-header";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { useCompanyById } from "@/hooks/company-by-id.hook";
import { useCurrentUserProfile } from "@/hooks/current-user-profile.hook";
import { mapCompanySizeToLabel } from "@/mappers/companies";
import { Building, Building4, Warning2 } from "iconsax-react";
import CompanyMetaField from "../../components/company-meta-field";
import CompanyForm from "./company-form";
import CompanySkeleton from "./company-skeleton";
import UsersCard from "./users-card";

const CompanyPage = () => {
  const { data: userProfile } = useCurrentUserProfile();

  const { data: company, isLoading: companyIsLoading } = useCompanyById(
    userProfile?.companyId || "",
  );

  return (
    <div>
      <PageHeader title="Perfil de empresa" icon={<Building4 size={24} />} />

      {companyIsLoading ? (
        <CompanySkeleton />
      ) : company ? (
        <div className="mt-4 grid grid-cols-1 gap-4 lg:grid-cols-2">
          <Card className="lg:col-span-2">
            <CardContent className="px-3 py-6">
              <div className="mb-6 flex items-center gap-2">
                <div className="flex aspect-square w-12 items-center justify-center rounded-full bg-[#615CB7] text-white">
                  <Building size={28} />
                </div>

                <h2 className="grow text-2xl font-semibold text-[#293038]">
                  {company.tradeName || company.name}
                </h2>

                <CompanyForm />
              </div>

              <div className="grid grid-cols-3 gap-4">
                <CompanyMetaField label="Razón social">
                  {company.name}
                </CompanyMetaField>

                <CompanyMetaField label="RUC">{company.taxId}</CompanyMetaField>

                <CompanyMetaField label="Dirección">
                  {company.address?.street}
                </CompanyMetaField>

                <CompanyMetaField label="Nombre comercial (trofeo)">
                  {company.tradeName}
                </CompanyMetaField>

                <CompanyMetaField label="Sitio web">
                  {company.website && (
                    <a
                      href={company.website}
                      target="_blank"
                      rel="noreferrer"
                      className="text-[#615CB7] underline"
                    >
                      {company.website}
                    </a>
                  )}
                </CompanyMetaField>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="px-3 py-6">
              <h3 className="mb-4 text-xl font-semibold text-[#13171B]">
                Descripción
              </h3>

              <div className="grid grid-cols-2 gap-4">
                <CompanyMetaField label="Sector">
                  {company.segment?.sector && (
                    <Badge variant="purple">{company.segment.sector}</Badge>
                  )}
                </CompanyMetaField>

                <CompanyMetaField label="Subsector">
                  {company.segment?.subsector && company.segment.subsector}
                </CompanyMetaField>

                <CompanyMetaField label="Tamaño">
                  {company.segment?.companySize && (
                    <Badge variant="green">
                      {mapCompanySizeToLabel(company.segment.companySize)}
                    </Badge>
                  )}
                </CompanyMetaField>

                <CompanyMetaField label="Principal producto o servicio">
                  {company.principalProduct}
                </CompanyMetaField>

                <CompanyMetaField label="Año de inicio de operaciones">
                  {company.yearOfOperationsStart}
                </CompanyMetaField>
              </div>
            </CardContent>
          </Card>

          <UsersCard />
        </div>
      ) : (
        <EmptyState
          icon={Warning2}
          className="mx-auto my-24"
          message="No se pudo cargar los datos de la empresa."
        />
      )}
    </div>
  );
};

export default CompanyPage;
